function onClosedWindow(win) {
  return new Promise(resolve => {
    var pollTimer = setInterval(function () {
      if (win.closed !== false) {
        // !== is required for compatibility with Opera
        clearInterval(pollTimer)
        resolve()
      }
    }, 200)
  })
}
export function compartirFacebook(url) {
  if (typeof window === 'undefined') {
    return Promise.resolve()
  }
  var pageUrl = encodeURIComponent(url)
  const popup = window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}&src=sdkpreparse`,
    '_blank',
    'width=600,height=400'
  )
  return onClosedWindow(popup)
}

export function shareOnTelegram(url) {
  var pageUrl = encodeURIComponent(url)
  var telegramUrl = 'https://t.me/share/url?url=' + pageUrl
  const popup = window.open(telegramUrl)
  return onClosedWindow(popup)
}

export function shareOnWhatsApp(url) {
  var pageUrl = encodeURIComponent(url)
  var whatsappUrl = 'https://api.whatsapp.com/send?text=' + pageUrl
  const popup = window.open(whatsappUrl)
  return onClosedWindow(popup)
}
